import { Dispatch, SetStateAction } from "react"
import { ObjectGeneric } from "../../../../../utils/types/generals"
import { Constants } from "../../../../../utils/constants"
import dayjs from "dayjs"
import { DaysWeek } from "../../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs"
import { TFunction } from "react-i18next"
import { toUnitTimeZone } from "../../../../../utils/methods/calcDate"
import { FrequencyEnum, ScheduleEnumType } from "../../../../calendar/pages/form/components/steps/configCalendar/enums"
import { AssignScheduleDetail } from "../../../../../service/userSchedule/response"
import { FrecuencyTypeTextResponse } from "../../../../calendar/pages/main/enums/enums"


export const formatresponseSchedule = ({ response, setData, setSelectedDays, setStartDate, t, setErrors, option, mimTimeZone }: { mimTimeZone: { code: string; value: number; }; option: ScheduleEnumType; setErrors: (value: SetStateAction<Record<string, string>>) => void; t: TFunction; response: AssignScheduleDetail, setData: (value: SetStateAction<ObjectGeneric>) => void; setSelectedDays: Dispatch<SetStateAction<number[]>>; setStartDate: Dispatch<SetStateAction<number | undefined>>; }) => {

  const timeZone = /* response.store?.storeTimeZone?.code ??  */ Constants.defaultTimeZone
  const dateStart = option == ScheduleEnumType.SERIE ? dayjs(`${response.serieStructure?.dateRangeStart}T${response.serieStructure?.timeStart}`) : dayjs(response.dateStart).tz(timeZone);
  const dateEnd = option == ScheduleEnumType.SERIE ? dayjs(`${response.serieStructure?.dateRangeEnd}T${response.serieStructure?.timeEnd}`): dayjs(response.dateEnd).tz(timeZone);

  const hoursStart = dateStart.hour();
  const minutesStart = dateStart.minute();
  const secondsStart = dateStart.second();
  const dateStartFormated = dayjs().hour(hoursStart).minute(minutesStart).second(secondsStart).millisecond(0)

  const hoursEnd = dateEnd.hour();
  const minutesEnd = dateEnd.minute();
  const secondsEnd = dateEnd.second();
  const dateEndFormated = dayjs().hour(hoursEnd).minute(minutesEnd).second(secondsEnd).millisecond(0)


  const getFrecuencyValue = (type: FrecuencyTypeTextResponse) => {
    let text: FrequencyEnum;
    switch (type) {
      case FrecuencyTypeTextResponse.CYCLICAL:
        text = FrequencyEnum.CYCLIC;
        break
      case FrecuencyTypeTextResponse.DAILY:
        text = FrequencyEnum.DAYLI;
        break
      case FrecuencyTypeTextResponse.WEEKLY:
        text = FrequencyEnum.WEEKLY;
        break
      case FrecuencyTypeTextResponse.UNIQUE:
        text = FrequencyEnum.UNIQUE;
        break
    }
    return text;
  }

  const daysToWork = response.serieStructure?.workingDays?.map((num: number) => num === 0 ? 7 : num) ?? [];

  setSelectedDays(daysToWork)

  const day = response.frequencyType !== FrecuencyTypeTextResponse.WEEKLY ? dayjs(dateStart).day() : response.serieStructure?.scheduleDay;
  setStartDate(day == 0 ? DaysWeek.SUNDAY : day)

  const frequency = !!response.frequencyType ? getFrecuencyValue(response.frequencyType as FrecuencyTypeTextResponse) : FrequencyEnum.UNIQUE

  setData(prev => ({
    ...prev,
    notified: response.notified,
    notifiedAdmin: response.notifyAdmin,
    user: response.userAssignId,
    store: response.store?.id,
    //falta el del store

    openQuestionnaire: !response.frequencyType,
    frequency: !!response.frequencyType ? getFrecuencyValue(response.frequencyType as FrecuencyTypeTextResponse) : FrequencyEnum.UNIQUE,
    from: !!response.frequencyType ? dateStart : null,
    to: !!response.frequencyType ? dateEnd : null,

    fromDateDaily: !!response.frequencyType ? dateStart : null,
    toDateDaily: !!response.frequencyType && frequency == FrequencyEnum.DAYLI ? dateEnd : null,
    fromDateCycli: !!response.frequencyType && response.frequencyType == FrecuencyTypeTextResponse.CYCLICAL ? dateStart : null,
    toDateCycli: !!response.frequencyType && response.frequencyType == FrecuencyTypeTextResponse.CYCLICAL ? dateEnd : null,
    fromDateWeekly: !!response.frequencyType && response.frequencyType == FrecuencyTypeTextResponse.WEEKLY ? dateStart : null,
    toDateWeekly: !!response.frequencyType && response.frequencyType == FrecuencyTypeTextResponse.WEEKLY ? dateEnd : null,

    startDateDaily: !!response.frequencyType ? dateStartFormated : null,
    endDateDaily: !!response.frequencyType ? dateEndFormated : null,
    startDate: !!response.frequencyType ? dateStartFormated : null,
    endDate: !!response.frequencyType ? dateEndFormated : null,

    duration: `${response.serieStructure?.duration}d`,
    dayOfWeek: response.serieStructure?.scheduleDay == 0 ? DaysWeek.MONDAY : response.serieStructure?.scheduleDay,

    maxToDay: response.serieStructure ? dayjs(`${response.serieStructure?.dateRangeEnd}T${response.serieStructure?.timeEnd}`) : null,

    serieId: response.serieStructure?.id
    /* durationCycli: !!response.frequencyType ? null, */

  }))


  if (response?.serieStructure?.duration && response?.serieStructure?.duration < 1) {
    setErrors(prev => ({
      ...prev,
      duration: t('general.validations.minimusOneDayToDuration')
    }))
  }

  if (Boolean(dateEndFormated) && (option == ScheduleEnumType.SERIE || option == ScheduleEnumType.UNIQUE) && (response.frequencyType as FrecuencyTypeTextResponse) == FrecuencyTypeTextResponse.DAILY) {
    let errorMessage = ''
    const start = dayjs(dateStartFormated);
    const end = dayjs(dateEndFormated);
    const diffInMinutes = end.diff(start, 'minute');
    if (diffInMinutes <= 5) { errorMessage = t('general.validations.minimus5minute') }
    setErrors(prev => ({
      ...prev,
      endDateDaily: errorMessage
    }))
  }

  if ( (dateStart || dateEnd) && (option == ScheduleEnumType.UNIQUE) && getFrecuencyValue(response.frequencyType as FrecuencyTypeTextResponse) == FrequencyEnum.UNIQUE ){
    if (Boolean(dateEnd)) {
      let errorMessage = ''
      if (dayjs(dateEnd).isBefore(dayjs(dateStart).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
      if (dayjs(dateEnd).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
      setErrors(prev => ({
        ...prev,
        to: errorMessage
      }))
    }
  }

  if ( (dateStart || dateEnd) && (option == ScheduleEnumType.RECURRENT) ){

    const frequency = !!response.frequencyType ? getFrecuencyValue(response.frequencyType as FrecuencyTypeTextResponse) : FrequencyEnum.UNIQUE

    if (frequency == FrequencyEnum.DAYLI) {
      if (Boolean(dateEnd)) {
        let errorMessage = ''
        if (dayjs(dateEnd).isBefore(dayjs(dateStart).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        if (dayjs(dateEnd).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
        if (dayjs(dateEnd).isAfter(dayjs(dateStart).add(24, 'hour'))) { errorMessage = t('general.validations.maximum24Hours'); }
        setErrors(prev => ({
          ...prev,
          to: errorMessage
        }))
      }
    } else {
      if (Boolean(dateEnd)) {
        let errorMessage = ''
        if (dayjs(dateEnd).isBefore(dayjs(dateStart).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        if (dayjs(dateEnd).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
        setErrors(prev => ({
          ...prev,
          to: errorMessage
        }))
      }
    }
  }

  if ((dateStart || dateEnd) && (option == ScheduleEnumType.SERIE || option == ScheduleEnumType.UNIQUE)) {

    let errorMessage = ''
    const start = dayjs(dateStart);
    const end = dayjs(dateEnd);

    if ((response.frequencyType as FrecuencyTypeTextResponse) == FrecuencyTypeTextResponse.CYCLICAL) {
      if (Boolean(dateEnd)) {
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
        setErrors(prev => ({
          ...prev,
          toDateCycli: errorMessage
        }))
      }
    }

    if ((response.frequencyType as FrecuencyTypeTextResponse) == FrecuencyTypeTextResponse.DAILY) {
      if (Boolean(dateEnd)) {
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
        setErrors(prev => ({
          ...prev,
          toDateDaily: errorMessage
        }))
      }
    }

    if ((response.frequencyType as FrecuencyTypeTextResponse) == FrecuencyTypeTextResponse.WEEKLY) {
      if (Boolean(dateEnd)) {
        const diffInDays = end.diff(start, 'day');
        if (diffInDays < 7) { errorMessage = t('general.validations.minimus7Day') }
        setErrors(prev => ({
          ...prev,
          toDateWeekly: errorMessage
        }))
      }
    }
  }

}